import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{ width: "100%" }}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function PurchasePreorderTabs({ ...props }) {
    const [value, setValue] = React.useState(0);
    const [t] = useTranslation("global");

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }} >
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label={t("purchasepreorders.tabs.general")} {...a11yProps(0)} />
                    <Tab label={t("purchasepreorders.tabs.financial")} {...a11yProps(1)} />
                    <Tab label={t("purchasepreorders.tabs.annotations")} {...a11yProps(2)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {props.Update}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                {props.Financial}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                {props.Annotations}
            </CustomTabPanel>
        </Box>
    );
}
